import { updateQueryString } from './includes/shared/utils.js';
import { elements } from './includes/news/elements.js';
import { preloadFormFields } from './includes/news/preloadFormFields.js';
import { fetchResults } from './includes/news/fetchResults.js';
import { bindFormElements } from './includes/news/bindFormElements.js';
import { initializeCalendarFields } from './includes/news/calendar.js';

const isNewsPage = () => {
    return !!elements.searchForm && !!elements.resultsContainer;
};

export const initializeSearchNews = () => {
    if (!isNewsPage()) return;

    const { allChoices } = preloadFormFields();
    bindFormElements(fetchResults, updateQueryString, allChoices);
    initializeCalendarFields(fetchResults, updateQueryString);
    fetchResults();
};
